import { useEffect, useState } from "react";

import {
  getAppVersion,
  isAppVersionOutdated,
  MIN_REQUIRED_APP_VERSION,
} from "../helpers/appVersion.helpers";

type UseAppVersionResult = {
  appVersion: string;
  minimumAppVersion: string;
  isAppOutdated: boolean;
};
export default function useAppVersion(): UseAppVersionResult {
  const [appVersion, setAppVersion] = useState<string>("");
  const [isAppOutdated, setIsAppOutdated] = useState<boolean>(false);

  const fetchAppInfo = async () => {
    const version = await getAppVersion();

    if (!version) {
      return null;
    }

    setAppVersion(version);

    const isOutOfDate = isAppVersionOutdated(version);
    setIsAppOutdated(isOutOfDate);
  };

  useEffect(() => {
    fetchAppInfo();
  }, []);

  return {
    appVersion,
    minimumAppVersion: MIN_REQUIRED_APP_VERSION,
    isAppOutdated,
  };
}
